import PropTypes from 'prop-types'
import React from 'react'

import Icon from 'components/Icon'
import Link from 'components/Link'
import { Text } from 'styles/components/typography'

import './LinkInlineArrowLong.scss'

/**
 * Component of inline link with text and long arrow
 * @return Component — LinkInlineArrowLong
 */

const TYPOGRAPHY_SIZES = {
  base: 'base',
  h2: 'lg',
  h1: 'xl',
}

const LinkInlineArrowLong = props => {
  const {
    size,
    className,
    classNameArrow,
    isHoverable,
    isWhite,
    children,
    to,
    as,
  } = props
  const strokeWidth = size === TYPOGRAPHY_SIZES.base ? '1.2' : '2'
  const iconColor = isWhite ? 'white' : 'black'
  const arrowSizeClassNames = `link-inline-long__arrow--${size}`
  const classNameBlocked = isHoverable ? '' : 'no-hover'
  let textSizesClassNames = `text--${TYPOGRAPHY_SIZES[size]} `
  let content = null

  if (isWhite) {
    textSizesClassNames += 'link-inline-long__text--white'
  }

  if (typeof children === 'object') {
    content = children
  } else {
    content = <span dangerouslySetInnerHTML={{ __html: children }} />
  }

  const inner = (
    <div className="link-inline-long__content">
      <Text
        as="span"
        className={`link-inline-long__text ${textSizesClassNames}`}
      >
        {content}
      </Text>
      &nbsp;
      <div
        className={`link-inline-long__wrapper-arrow ml-05 pr-15 ${classNameArrow}`}
      >
        <div className={`link-inline-long__arrow ${arrowSizeClassNames}`}>
          <Icon
            id="arrow_long_right"
            color={iconColor}
            strokeWidth={strokeWidth}
          />
        </div>
      </div>
    </div>
  )

  if (as === 'Link' && to) {
    return (
      <Link
        to={to}
        className={`link-inline-long ${classNameBlocked} ${className}`}
      >
        {inner}
      </Link>
    )
  }

  if (as === 'a' && to) {
    return (
      <a
        href={to}
        target="_blank"
        rel="noopener noreferrer"
        className={`link-inline-long ${classNameBlocked} ${className}`}
      >
        {inner}
      </a>
    )
  }

  return (
    <span className={`link-inline-long ${classNameBlocked} ${className}`}>
      {inner}
    </span>
  )
}

LinkInlineArrowLong.propTypes = {
  /** Text in link */
  children: PropTypes.node.isRequired,

  /** Kind of wrapper component */
  as: PropTypes.oneOf(['a', 'Link', 'span']),

  /** ClassName for root tag */
  className: PropTypes.string,

  /** ClassName for arrow node */
  classNameArrow: PropTypes.string,

  /** Change default color of arrow to white */
  isHoverable: PropTypes.bool,

  /** Flag to control is it hoverable element */
  isWhite: PropTypes.bool,

  /** Size of arrow equal typography sizes */
  size: PropTypes.oneOf(Object.keys(TYPOGRAPHY_SIZES)),

  /** Location */
  to: PropTypes.string,
}

LinkInlineArrowLong.defaultProps = {
  as: 'Link',
  className: '',
  classNameArrow: '',
  size: 'base',
  isWhite: false,
  isHoverable: true,
}

export default LinkInlineArrowLong
